import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Alert, InfoCard, Loader, genericTexts, SortableTable } from 'hub-web-lib'
import { ACTIVITY } from 'js/constants/vocabulary'
import { UPDATE_NOTIFICATION_CONTENT } from 'js/constants/action-types'
import { action } from 'js/actions'
import store from 'js/store'
import { connect } from 'react-redux'
import 'scss/UpdateActivity/ActivityInfo.scss'
import DdosApi from 'services/DdosApi'
import { getActivityInfoMetricsColumns, getActivityInfoMetricsTableData, getActivityMetricsValuesProps } from 'js/ui-helpers/metrics'
import { getActivityInfoCardData, getSelectedActivityTitle } from 'js/ui-helpers/activity'
import { activityCardInfoDefault } from 'js/constants/enums/activity'
import BackButton from 'components/Assets/BackButton/BackButton'
import { DDOS_RESILIENCE_MODULE } from 'js/constants/app-modules'

const mapStateToProps = state => {
    return {
        currentUser: state.currentUser,
        dashboardSettings: state.dashboardSettings,
        currentUserOrgs: state.currentUserOrgs
    }
}

const DdosActivityInfoComponent = ({ currentUser, dashboardSettings, currentUserOrgs }) => {
    const currentOrgId = currentUser?.current_org
    const location = useLocation()
    const [isLoading, setIsLoading] = useState(true)
    const [currentActivityInfo, setCurrentActivityInfo] = useState({})
    const currentActivityTitle = getSelectedActivityTitle(currentActivityInfo)
    const ddosValuesProps = getActivityMetricsValuesProps(dashboardSettings, DDOS_RESILIENCE_MODULE)

    const getActivityInfo = async () => {
        let info = location?.state?.activity
        if (info) {
            setCurrentActivityInfo(info)
            return
        }
        const activityId = (location?.pathname || '').split('/')[3]*1
        const activity = await DdosApi.getActivity(activityId)
        if (!activity || activity.error) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: genericTexts.defaultText.deletedError(ACTIVITY), notificationType: 'error' }))
            return
        }  
        activity.metrics = await DdosApi.getActivityMetrics(activityId)
        if (!activity.metrics || activity.metrics.error) activity.metrics = []
        const org = currentUserOrgs.find(o => o.id === currentOrgId) || { id: currentOrgId }
        activity.organization = org?.name || currentOrgId
        setCurrentActivityInfo(activity)
    }

    const cardData = getActivityInfoCardData(activityCardInfoDefault, currentActivityInfo)
    const metricsTableData = getActivityInfoMetricsTableData(currentActivityInfo, ddosValuesProps)
    const metricsTableColumns = getActivityInfoMetricsColumns(ddosValuesProps)


    useEffect( async () => {
        await getActivityInfo()
        setIsLoading(false)
    }, [])

    return (
        <div className='page-content dd-info activity-info'>
            <div className='page-header'>
                <BackButton />
                <h1 id='easm-activity-info'>{ACTIVITY} {currentActivityTitle} Info</h1>
            </div>
            {isLoading ? <Loader /> : currentActivityInfo.id ? <div className='report-info-con info-card-con'>
                <InfoCard cardData={cardData} />
                <h2 id='easm-mertics'>Metrics</h2>
                <SortableTable columns={metricsTableColumns} tableData={metricsTableData} itemsPerPage={0} tableId='ddos-activity-info-metrics-table' />
            </div> : <Alert message={`No data for this ${ACTIVITY}`} />}
        </div>
    )
}
const DdosActivityInfo = connect(mapStateToProps)(DdosActivityInfoComponent)
export default DdosActivityInfo